import React from 'react';
import { Card, Col } from 'react-bootstrap';

interface Props {
  user: any;
}

export const UserCard = (props: Props) => {
  return (
    <Col xs={2}>
      <Card>
        <Card.Header>
          <Card.Title>{props.user.name}</Card.Title>
        </Card.Header>
        <Card.Body>
          <Card.Text>
            <strong>{props.user.adId}</strong>
          </Card.Text>
          <Card.Text>
            <strong>{`Last logged in at ${new Date(props.user.LastLoggedInAt).toLocaleString('en-US')}`}</strong>
          </Card.Text>
        </Card.Body>
      </Card>
    </Col>
  );
};
